var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssigned({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.5,82l28.3-28.3l50,50l83-83L512,49L400.8,160.2L322.5,82z M481.4,136.1c19.8,36.8,30.3,78.1,30.3,121.1 c0,68.3-26.6,132.6-74.9,180.9c-48.3,48.3-112.6,74.6-180.9,74.6c-68.3,0-132.6-26.3-180.9-74.6C26.6,389.8,0,325.6,0,257.2 c0-68.3,26.6-132.6,74.9-180.9C123.3,28,187.5,1,255.9,1c27.1,0,53.5,4.5,78.5,12.6l-32.7,32.7c-14.8-3.2-30.1-4.9-45.9-4.9 C136.8,41.3,40,138.2,40,257.2c0,54.5,20.3,104.3,53.7,142.3c11.6-52,47.6-94.8,95.4-115.9c-19.9-18.2-32.5-44.3-32.5-73.4 c0-54.8,44.5-99.3,99.3-99.3c54.8,0,99.3,44.5,99.3,99.3c0,29-12.5,55.2-32.5,73.4c47.7,21.1,83.8,63.9,95.4,115.9 c33.4-38,53.7-87.8,53.7-142.3c0-32.6-7.3-63.5-20.2-91.2L481.4,136.1z M255.9,269.6c32.7,0,59.3-26.6,59.3-59.3 c0-32.7-26.6-59.3-59.3-59.3c-32.7,0-59.3,26.6-59.3,59.3C196.5,242.9,223.1,269.6,255.9,269.6z M255.9,473.1 c47.1,0,90.7-15.2,126.2-40.8c-1.9-68-57.7-122.7-126.2-122.7s-124.3,54.7-126.2,122.7C165.2,457.9,208.8,473.1,255.9,473.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.30cbc931a0409444de1f183df6106fb5.svg";
export { ForwardRef as ReactComponent };